module.exports = __webpack_public_path__ + "static/media/logo-smartkood.a3c49eaa.png";